export const noContextMethod: () => any = () => {
  throw Error('method used outside its supporting context')
}
